import { reservationRoom } from "../../../../model/reservation";
import moment from "moment";

export const getDateFromDayCode = (dayCode: string) => {
    if (dayCode) {
        let day = dayCode.substring(0, 4) + "-" + dayCode.substring(4, 6) + "-" + dayCode.substring(6, 8);
        return new Date(day);
    }
    return new Date();
}

export const getMinutesOfDay = (date: moment.Moment) => {
    return date.get("minute") + date.get("hours") * 60;
}

export const getReservationMinStartDate = (reservationRoom: reservationRoom) => {
    let minDate = undefined;
    //No Closign Day
    if (reservationRoom && reservationRoom.reservationSlots && reservationRoom.reservationSlots.length > 0) {
        let openDate = moment(getDateFromDayCode(reservationRoom.dayCode))
            .set({
                hour: reservationRoom.openingDetail.openingTime.hours,
                minute: reservationRoom.openingDetail.openingTime.minutes,
                seconds: 0
            });
        let firstSlot = reservationRoom.reservationSlots[0] ? moment(reservationRoom.reservationSlots[0].startingTime) : undefined;
        minDate = firstSlot === undefined || getMinutesOfDay(openDate) <= getMinutesOfDay(firstSlot) ? openDate : firstSlot;
    }
    return minDate;
}

export const getReservationMaxEndtDate = (reservationRoom: reservationRoom) => {
    let maxDate = undefined;
    //No Closign Day
    if (reservationRoom && reservationRoom.reservationSlots && reservationRoom.reservationSlots.length > 0) {
        let closeDate = moment(getDateFromDayCode(reservationRoom.dayCode))
            .set({
                hour: reservationRoom.openingDetail.closingTime.hours,
                minute: reservationRoom.openingDetail.closingTime.minutes,
                seconds: 0
            });
        let lastSlot = reservationRoom.reservationSlots[reservationRoom.reservationSlots.length - 1] ?
            moment(reservationRoom.reservationSlots[reservationRoom.reservationSlots.length - 1].startingTime)
                .add(reservationRoom.reservationSlots[reservationRoom.reservationSlots.length - 1].duration, "minute") : undefined;
        maxDate = lastSlot === undefined || getMinutesOfDay(closeDate) >= getMinutesOfDay(lastSlot) ? closeDate : lastSlot;
    }
    return maxDate;
}